import { Component,OnInit,OnDestroy,AfterViewInit,Injectable } from '@angular/core';
import { NgbModal,NgbActiveModal,ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { Subject } from 'rxjs';
import {
    NgbDate
    ,NgbCalendar
    ,NgbDateParserFormatter
    ,NgbDatepickerI18n
    ,NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';

import {
    I18n
    ,I18nDatePicker
    ,FvmsCommonService
} from "src/app/shared/service";
import {
    FilterLeftPadd
} from "src/app/shared/filter";

@Component({
    selector: "date-selector"
    ,templateUrl: "./date.selector.component.html"
    ,styleUrls: ["./date.selector.component.scss"]
    ,providers: [I18n, {provide: NgbDatepickerI18n, useClass: I18nDatePicker},FilterLeftPadd]
})
export class DateSelectorComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    datetimeInfo:any;
    hoveredDate: NgbDate;
    isSaturday = (date: NgbDate) =>  this.calendar.getWeekday(date) == 6;
    isSunday = (date: NgbDate) =>  this.calendar.getWeekday(date) == 7;

    displayDateFrom:NgbDate;
    displayDateTo:NgbDate;
    inputDateFrom:string;
    inputDateTo:string;
    minDate:NgbDate = new NgbDate(2017,1,1);
    maxDate:NgbDate;
    maxRange:number = 4;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService: FvmsCommonService
        ,private calendar: NgbCalendar
        ,public formatter: NgbDateParserFormatter
        ,private filterLeftPadd:FilterLeftPadd
    ) {
        this.datetimeInfo = this.fvmsCommonService.getDateInfo();
        //this.maxDate = new NgbDate(this.calendar.getToday().year+1,12,31);
        this.maxDate = this.calendar.getToday();
        //초기값 없을경우 설정
        if(!this.datetimeInfo){
            let today = this.calendar.getToday();
            //let nextDay = this.calendar.getNext(today, 'd', 0);
            let nextDay = this.calendar.getToday();
            this.datetimeInfo = {
                fromDate : today
                ,toDate : nextDay
                ,fromTime : "00:00:00" //시간까지 선택으로 바뀌면 사용
                ,toTime : "23:59:59" //시간까지 선택으로 바뀌면 사용
            };
            this.fvmsCommonService.setDateInfo(this.datetimeInfo);
        }
    }

    ngOnInit() {
        if(this.datetimeInfo){
            this.displayDateFrom = this.datetimeInfo.fromDate;
            this.displayDateTo = this.datetimeInfo.toDate;
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
        // this.modalService.dismissAll();
    }
    
    ngAfterViewInit() {}

    onDateSelection(date: NgbDate) {
        if (!this.displayDateFrom && !this.displayDateTo) {
            //처음 클릭
            this.displayDateFrom = date;
            this.inputDateFrom = `${this.filterLeftPadd.transform(this.displayDateFrom.year,4)}-${this.filterLeftPadd.transform(this.displayDateFrom.month,2)}-${this.filterLeftPadd.transform(this.displayDateFrom.day,2)}`;
        } else if (this.displayDateFrom && !this.displayDateTo) {
            // && date.after(this.displayDateFrom)
            //뒤에 선택한 일자가 먼저 선택한 일자보다 작은 경우 스왑
            if(date.before(this.displayDateFrom) === true){
                let tmpDate = new NgbDate(this.displayDateFrom.year,this.displayDateFrom.month,this.displayDateFrom.day);
                let newDate = new NgbDate(date.year,date.month,date.day);
                this.displayDateFrom = newDate;
                date = tmpDate;
                this.inputDateFrom = `${this.filterLeftPadd.transform(this.displayDateFrom.year,4)}-${this.filterLeftPadd.transform(this.displayDateFrom.month,2)}-${this.filterLeftPadd.transform(this.displayDateFrom.day,2)}`;
            }

            if(date.equals(this.displayDateFrom) === false){
                let tmpMinDate = this.calendar.getNext(date, 'd', this.maxRange * -1);
                if(this.displayDateFrom.before(tmpMinDate) === true){
                    this.initDateInfo();
                    alert("최대 5일까지 검색 가능합니다");
                    return;
                }
            }

            this.displayDateTo = date;
            this.inputDateTo = `${this.filterLeftPadd.transform(this.displayDateTo.year,4)}-${this.filterLeftPadd.transform(this.displayDateTo.month,2)}-${this.filterLeftPadd.transform(this.displayDateTo.day,2)}`;
            this.datetimeInfo.fromDate = this.displayDateFrom;
            this.datetimeInfo.toDate = this.displayDateTo;
            // this.fvmsCommonService.setDateInfo(this.datetimeInfo);
        } else {
            //from,to 선택 후에 다시 클릭 -> 초기화
            this.initDateInfo();
            this.displayDateFrom = date;
            this.inputDateFrom = `${this.filterLeftPadd.transform(this.displayDateFrom.year,4)}-${this.filterLeftPadd.transform(this.displayDateFrom.month,2)}-${this.filterLeftPadd.transform(this.displayDateFrom.day,2)}`;
        }
    }

    isHovered(date: NgbDate) {
        return this.displayDateFrom && !this.displayDateTo && this.hoveredDate && date.after(this.displayDateFrom) && date.before(this.hoveredDate);
    }
    
    isInside(date: NgbDate) {
        return date.after(this.displayDateFrom) && date.before(this.displayDateTo);
    }
    
    isRange(date: NgbDate) {
        return date.equals(this.displayDateFrom) || date.equals(this.displayDateTo) || this.isInside(date) || this.isHovered(date);
    }

    initDateInfo(){
        this.displayDateFrom = undefined;
        this.displayDateTo = undefined;
        this.inputDateFrom = undefined;
        this.inputDateTo = undefined;
        this.minDate = new NgbDate(2017,1,1);
        this.maxDate = this.calendar.getToday();
    }

    clickOpen(datepicker){
        this.initDateInfo();
        this.displayDateFrom = this.datetimeInfo.fromDate;
        this.displayDateTo = this.datetimeInfo.toDate;
        datepicker.toggle();
    }

    clickOk(datepicker){
        if(this.displayDateFrom){
            if(!this.displayDateTo){
                this.displayDateTo = this.displayDateFrom;
            }
            this.datetimeInfo.fromDate = this.displayDateFrom;
            this.datetimeInfo.toDate = this.displayDateTo;
            this.fvmsCommonService.setDateInfo(this.datetimeInfo);
        }
        datepicker.close();
    }

    selectToday(){
        this.initDateInfo();
        this.onDateSelection(this.calendar.getToday());
    }
}